<template>
  <v-container fluid>
    <div class="row">
      <v-col cols="12" lg="6" md="6">
        <ScaleList />
      </v-col>
      <v-col cols="12" lg="6" md="6">
        <ScaleSwapList />
      </v-col>
    </div>
  </v-container>
</template>

<script>
import ScaleList from '../scale/components/ScaleList'
import ScaleSwapList from '../scale/ScaleSwaps/components/ScaleSwapsList'
export default {
  name: 'Home',
  components: { ScaleList, ScaleSwapList },
}
</script>

<style lang="css" scoped>
:focus {
  outline: -webkit-focus-ring-color none !important;
}
</style>
